(function () {
  if (window.__AG_PB_LEVELS_INIT__) return;
  window.__AG_PB_LEVELS_INIT__ = true;

  var ACCORDION_MS = 340;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setItemOpen(item, open) {
    var toggle = item.querySelector('.js-ag-pb-levels-toggle');
    var body = item.querySelector('.ag-pb-levels__body');
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!body) return;

    if (open) {
      body.removeAttribute('hidden');
      return;
    }

    if (prefersReducedMotion()) {
      body.setAttribute('hidden', '');
      return;
    }

    window.setTimeout(function () {
      if (!item.classList.contains('is-open')) {
        body.setAttribute('hidden', '');
      }
    }, ACCORDION_MS);
  }

  function toggleItem(root, item) {
    if (!item) return;
    var toggle = item.querySelector('.js-ag-pb-levels-toggle');
    if (toggle && toggle.disabled) return;

    var willOpen = !item.classList.contains('is-open');

    root.querySelectorAll('.js-ag-pb-levels-item.is-open').forEach(function (openItem) {
      if (openItem !== item) setItemOpen(openItem, false);
    });

    setItemOpen(item, willOpen);
  }

  function initRoot(root) {
    if (!root || root.dataset.agPbLevelsReady === 'true') return;
    root.dataset.agPbLevelsReady = 'true';

    root.addEventListener('click', function (event) {
      if (event.target.closest('a, input, textarea, select')) return;

      var card = event.target.closest('.ag-pb-levels__card');
      if (!card || !root.contains(card)) return;

      var item = card.closest('.js-ag-pb-levels-item');
      if (!item) return;

      event.preventDefault();
      toggleItem(root, item);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var toggle = event.target.closest('.js-ag-pb-levels-toggle');
      if (!toggle || !root.contains(toggle)) return;
      event.preventDefault();
      var item = toggle.closest('.js-ag-pb-levels-item');
      toggleItem(root, item);
    });

    root.querySelectorAll('.js-ag-pb-levels-item').forEach(function (item) {
      setItemOpen(item, false);
    });
  }

  function initAll(scope) {
    var rootEl = scope && scope.querySelectorAll ? scope : document;
    rootEl.querySelectorAll('.js-ag-pb-levels').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('.js-ag-pb-levels').forEach(function (root) {
      root.dataset.agPbLevelsReady = '';
      initRoot(root);
    });
  });
})();
